import { render, staticRenderFns } from "./Mediator.vue?vue&type=template&id=244d63a8&scoped=true&"
import script from "./Mediator.vue?vue&type=script&lang=ts&"
export * from "./Mediator.vue?vue&type=script&lang=ts&"
import style0 from "./Mediator.vue?vue&type=style&index=0&id=244d63a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d63a8",
  null
  
)

export default component.exports